import React from 'react';
import { Section } from './ui/Section';
export function BenefitsTimeline() {
  const steps = [{
    days: '3-7 Días',
    title: 'Sensación de Ligereza',
    desc: "La pesadez extrema comienza a disiparse. Tu metabolismo se activa y te sientes menos 'lleno' después de comer."
  }, {
    days: '7-14 Días',
    title: 'Menos Hinchazón y Grasa Visible',
    desc: 'La ropa empieza a sentirse más holgada en la cintura. La retención de líquidos disminuye y comienza la quema de grasa localizada.'
  }, {
    days: '21-30 Días',
    title: 'Silueta Definida y Grasa Reducida',
    desc: 'Tu abdomen se ve visiblemente más plano. La grasa abdominal se ha reducido notablemente. Recuperas la confianza al mirarte al espejo.'
  }, {
    days: '45+ Días',
    title: 'Mantenimiento Total',
    desc: 'Tu metabolismo se ha reactivado completamente. Mantienes un abdomen más plano con más energía y vitalidad diaria.'
  }];
  return <Section background="green" className="text-white" data-id="element-6">
      <div className="text-center mb-12" data-id="element-7">
        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-8">
          Lo que experimentarás
        </h2>
        <p className="text-green-100 text-lg max-w-2xl mx-auto" data-id="element-9">
          La constancia es clave. StingFit trabaja progresivamente para
          resultados duraderos.
        </p>
      </div>

      <div className="grid md:grid-cols-4 gap-6" data-id="element-10">
        {steps.map((step, i) => <div key={i} className="relative bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-colors" data-id="element-11">
            <div className="text-[#D4AF37] font-bold text-xl mb-2" data-id="element-12">
              {step.days}
            </div>
            <h3 className="font-bold text-white text-lg mb-3" data-id="element-13">{step.title}</h3>
            <p className="text-green-100 text-sm leading-relaxed" data-id="element-14">
              {step.desc}
            </p>
          </div>)}
      </div>
    </Section>;
}